import { render, staticRenderFns } from "./ModalOrientacaoPlano.vue?vue&type=template&id=40af638e"
import script from "./ModalOrientacaoPlano.vue?vue&type=script&lang=js"
export * from "./ModalOrientacaoPlano.vue?vue&type=script&lang=js"
import style0 from "./ModalOrientacaoPlano.vue?vue&type=style&index=0&id=40af638e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports